import React from "react";
import { Typography } from "@material-ui/core";
import uuidv1 from "uuid/v1";

var headerViewerLink = function headerViewerLink(content, linksActive) {
  // console.log("headerViewerLink content", content);
  if (content && content.blocks) {
    var auxContent = [];
    content.blocks.filter(function (block) {
      return block.type.includes("header-");
    }).forEach(function (block) {
      var spaces = block.type.substring(7, block.type.length);
      var marginLeft;
      var typeHeader = 0;

      switch (spaces) {
        case "one":
          typeHeader = 1;
          marginLeft = "0px";
          break;

        case "two":
          typeHeader = 2;
          marginLeft = "16px";
          break;

        case "three":
          typeHeader = 3;
          marginLeft = "32px";
          break;

        case "four":
          typeHeader = 4;
          marginLeft = "48px";
          break;

        case "five":
          typeHeader = 5;
          marginLeft = "64px";
          break;

        case "six":
          typeHeader = 6;
          marginLeft = "80px";
          break;

        default:
          break;
      }

      if (linksActive) {
        var id = uuidv1();
        auxContent.push({
          html: /*#__PURE__*/React.createElement("a", {
            href: "#" + id,
            style: {
              color: "inherit",
              textDecoration: "none"
            }
          }, /*#__PURE__*/React.createElement(Typography, {
            variant: "body1",
            style: {
              marginLeft: marginLeft,
              wordWrap: "break-word"
            }
          }, block.text)),
          link: id,
          type: typeHeader
        });
      } else {
        auxContent.push( /*#__PURE__*/React.createElement(Typography, {
          variant: "body1",
          style: {
            marginLeft: marginLeft,
            wordWrap: "break-word"
          }
        }, block.text));
      }
    });
    return auxContent;
  }

  return null;
};

export { headerViewerLink };